import React, { useState, useEffect } from "react";
import Table from "../../../component/table";
import SimpleBarReact from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment/moment";
import { getBookingSignedUrl, getPerformanceSignedUrl, getTodoPerformanceFiles } from "../../../redux/actions/todoPerformance";
import { decryptData } from "../../../utils";
import { useParams } from "react-router-dom";
import { getTemplateValuesByOrderId } from "../../../redux/actions/salesOrder";

function DocumentTab() {
  const { documents, bookingFileUpload, performancedata } = useSelector(
    (state) => state.todoPerformance
  );
  const [collapse, setCollapse] = useState([]);
  const [documentList, setDocumentList] = useState([]);
  const [fileUpload, setFileUpload] = useState([]);
  const dispatch = useDispatch();
  const { activity_assignment_id } = useParams();
  const [loader, setLoader] = useState(false);
  const [ bookingFiles, setBookingFiles ] = useState(bookingFileUpload);

  useEffect(() => {
    setLoader(true);
    dispatch(getTodoPerformanceFiles(activity_assignment_id, (res) =>{
      setLoader(false);
    }))
  }, []);

  useEffect(() => {

    const inventory_order_id =  performancedata?.inventory_order_id ? performancedata.inventory_order_id : null;

    if(inventory_order_id){
      dispatch(
        getTemplateValuesByOrderId(inventory_order_id, (res) => {
          if (res.status === 1) {
            let files = res.data.file_uploads ?? [];
            setBookingFiles(files)
          }
        })
      );
    }
  }, [performancedata]);

  /* ** Creating function to toggle the collapse button */
  const toggleCollapse = (index) => {
    if (collapse.includes(index)) {
      setCollapse(collapse.filter((item) => item !== index));
    } else {
      setCollapse([...collapse, index]);
    }
  };

  useEffect(() => {
    if (documents.length > 0) {
      const documentArray = [];
      documents.map((document) => {
        if (document.type === "Document") {
          const obj = {
            todo_id: document.activity_id,
            toDoName: document.todo_name,
            documentList: [
              {
                document_id: document.activity_performance_file_upload_id,
                docName: document.file_name,
                docUrl: document.file_path,
                assetName: "",
                date: moment(document.uploaded_on).format(
                  "DD MMM, YYYY - HH:mm a"
                ),
              },
            ],
          };
          documentArray.push(obj);
        } else {
          if (
            documentArray.some((item) => item.todo_id === document.activity_id)
          ) {
            const containerBasedTodoIndex = documentArray.findIndex(
              (todo) => todo.todo_id === document.activity_id
            );
            documentArray[containerBasedTodoIndex].documentList.push({
              document_id: document.activity_performance_file_upload_id,
              docName: document.file_name,
              docUrl: document.file_path,
              assetName: "",
              date: moment(document.uploaded_on).format(
                "DD MMM, YYYY - HH:mm a"
              ),
            });
          } else {
            const obj = {
              todo_id: document.activity_id,
              toDoName: document.todo_name,
              documentList: [
                {
                  document_id: document.activity_performance_file_upload_id,
                  docName: document.file_name,
                  docUrl: document.file_path,
                  assetName: "",
                  date: moment(document.uploaded_on).format(
                    "DD MMM, YYYY - HH:mm a"
                  ),
                },
              ],
            };
            documentArray.push(obj);
          }
        }
      });
      setDocumentList(documentArray);
    }
  }, [documents]);

  useEffect(() => {
    if (bookingFiles.length > 0) {
      const uploadArray = [];
      bookingFiles.map((document) => {
        const obj = {
          booking_file_upload_id: document.booking_file_upload_id,
          documentList: [
            {
              docName: document.file_name,
              docUrl: document.file_path,
              date: moment(document.createdAt).format("DD MMM, YYYY - HH:mm a"),
              booking_file_upload_id: document.booking_file_upload_id
            },
          ],
        };
        uploadArray.push(obj);
      });
      setFileUpload(uploadArray);
    }
  }, [bookingFiles]);

  const downloadPerformanceDocuments = (document_id) => {
    const request = {
      document_id,
      onSuccess: (data) => {
        const url = decryptData(data)
        window.open(url, "_blank")
      },
      onError: (error) => {
        console.log("error occur in downloading ---", error);
      },
    };
    dispatch(getPerformanceSignedUrl(request));
  };

  const downloadBookingDocuments = (document_id) => {
    const request = {
      document_id,
      onSuccess: (data) => {
        const url = decryptData(data)
        window.open(url, "_blank")
      },
      onError: (error) => {
        console.log("error occur in downloading ---", error);
      },
    };
    dispatch(getBookingSignedUrl(request));
  };

  return loader ? (
    <div className="h-[90vh] flex justify-center items-center">
      <div class="px-6">
        <svg
          className="animate-spin w-12 h-12 fill-current shrink-0"
          viewBox="0 0 16 16"
        >
          <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
        </svg>
      </div>
    </div>
  ) : (
    <div
      className="sm:py-2 h-screen"
      style={{ maxHeight: "calc(100vh - 136px)" }}
    >
      <SimpleBarReact style={{ maxHeight: "calc(100vh - 145px)" }}>
        <Table
          heads={[
            {
              headName: "File Name",
              isSort: false,
              value: "File Name",
            },
            { headName: "To Do", isSort: false, value: "To Do" },
            {
              headName: "Uploaded At",
              isSort: false,
              value: "Uploaded At",
            },
            { headName: "Action", isSort: false, value: "Action" },
          ]}
          tClass="table-fixed w-full border-separate border-spacing-y-2"
          hClass="text-sm leading-2 tracking-tight font-semibold text-[#1E293B] bg-[--bg-color-50] sticky top-0"
          bClass="text-sm"
          thClass="px-2 py-3 whitespace-nowrap text-left last:text-center font-semibold first:pl-4 first:rounded-l-md last:rounded-r-md max-w-1/4 sticky top-0"
        >
          {fileUpload.length > 0 &&
            fileUpload.map((item, index) => {
              const { documentList } = item;
              return (
                <>
                  <tr key={index} className="bg-blue-100">
                    <td
                      title={
                        documentList.length > 1
                          ? `${documentList.length} Files`
                          : documentList[0].docName
                      }
                      className="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 font-semibold text-[#1E293B] text-left rounded-l-md max-w-1/4 truncate space-x-4"
                    >
                      <span>
                        {documentList.length > 1
                          ? `${documentList.length} Files`
                          : documentList[0].docName}
                      </span>
                    </td>
                    <td
                      title="booking-files"
                      className="px-2 py-2 text-sm font-semibold leading-4 tracking-tight first:pl-4  text-[#1E293B] text-left max-w-1/4 truncate"
                    >
                      Booking Files
                    </td>
                    <td
                      title={
                        documentList.length > 1 ? "" : documentList[0].date
                      }
                      className="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4  text-[#1E293B] text-left max-w-1/4 truncate"
                    >
                      {documentList.length > 1 ? "" : documentList[0].date}
                    </td>
                    <td
                      className={`px-2 py-2 whitespace-nowrap text-center text-sm rounded-r-md leading-4 tracking-tight text-[--bg-color-500] font-semibold`}
                    >
                      <a
                        // href={`${documentList[0].docUrl}`}
                        // download={documentList[0].docName}
                        className={`cursor-pointer ${
                          documentList.length > 1 && "pl-[18px]"
                        }`}
                        onClick={() => downloadBookingDocuments(item.booking_file_upload_id)}
                      >
                        {documentList.length > 1 ? "" : "Download"}
                      </a>
                    </td>
                  </tr>
                </>
              );
            })}
          {documentList.length > 0 &&
            documentList.map((item, index) => {
              const { toDoName, documentList } = item;
              return (
                <>
                  <tr key={index}>
                    <td
                      title={
                        documentList.length > 1
                          ? `${documentList.length} Files`
                          : documentList[0].docName
                      }
                      className="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 font-semibold text-[#1E293B] text-left bg-[--bg-color-50] rounded-l-md max-w-1/4 truncate space-x-4"
                    >
                      {documentList.length > 1 && (
                        <span
                          className={`fa-solid fa-chevron-down transition-transform ${
                            collapse.includes(index) && "rotate-180"
                          } text-[#9C9C9C] cursor-pointer`}
                          onClick={(e) => toggleCollapse(index)}
                        ></span>
                      )}

                      <span>
                        {documentList.length > 1
                          ? `${documentList.length} Files`
                          : documentList[0].docName}
                      </span>
                    </td>
                    <td
                      title={toDoName}
                      className="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4  text-[#1E293B] text-left bg-[--bg-color-50] rounded-l-md max-w-1/4 truncate"
                    >
                      {toDoName}
                    </td>
                    <td
                      title={
                        documentList.length > 1 ? "" : documentList[0].date
                      }
                      className="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4  text-[#1E293B] text-left bg-[--bg-color-50] rounded-l-md max-w-1/4 truncate"
                    >
                      {documentList.length > 1 ? "" : documentList[0].date}
                    </td>
                    <td
                      className={`px-2 py-2 whitespace-nowrap text-center text-sm bg-[--bg-color-50] rounded-r-md leading-4 tracking-tight text-[--bg-color-500] font-semibold`}
                    >
                      <a
                        // download={!documentList.length > 1 && documentList[0].docName}
                        onClick={() =>
                          downloadPerformanceDocuments(documentList[0].document_id)
                        }
                        className={`${
                          documentList.length > 1
                            ? "pointer-events-none pl-[18px]"
                            : "cursor-pointer"
                        }`}
                      >
                        {documentList.length > 1 ? "" : "Download"}
                      </a>
                    </td>
                  </tr>
                  {collapse.includes(index) &&
                    documentList.map((documentElement) => {
                      return (
                        <tr>
                          <td colSpan="4">
                            <div className="px-1 py-2 text-sm leading-4 tracking-tight first:pl-4 text-[#1E293B] text-left bg-[--bg-color-50] rounded-md max-w-[95%] ml-auto flex items-center justify-between ">
                              <div
                                title={documentElement.docName}
                                className="w-[20%] truncate"
                              >
                                {documentElement.docName}
                              </div>
                              <div
                                title={documentElement.assetName}
                                className="w-1/4 truncate"
                              >
                                {documentElement.assetName}
                              </div>
                              <div
                                title={documentElement.date}
                                className="w-1/4 truncate"
                              >
                                {documentElement.date}
                              </div>
                              <div className="w-1/4 text-center leading-4 tracking-tight text-[--bg-color-500] font-semibold">
                                <a
                                  className="pr-[6px] cursor-pointer"
                                  // href={`http://localhost:3000/todo_performance/downloads/${documentElement.document_id}`}
                                  // target="_blank"
                                  onClick={() =>
                                    downloadPerformanceDocuments(
                                      documentElement.document_id
                                    )
                                  }
                                >
                                  Download
                                </a>
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                </>
              );
            })}
        </Table>
      </SimpleBarReact>
    </div>
  );
}

export default DocumentTab;
